/** Package rates share their own stock and the largest stock pool of their room type. */
export function getPackageStockBudgets(views: ReadonlyArray<App.OfferPackageOptionView>) {
  const pkgOptionAvailableRooms: Record<string, number> = {}
  const roomTypeAvailableRooms: Record<string, number> = {}
  for (const view of views) {
    const packageKey = view.package.uniqueKey
    const stock = view.availableRooms ?? 0
    // Occupancy quotes share inventory; use their conservative current limit.
    pkgOptionAvailableRooms[packageKey] = Math.min(pkgOptionAvailableRooms[packageKey] ?? stock, stock)
  }
  for (const view of views) {
    const roomTypeId = view.package.roomType.id
    roomTypeAvailableRooms[roomTypeId] = Math.max(roomTypeAvailableRooms[roomTypeId] ?? 0, pkgOptionAvailableRooms[view.package.uniqueKey])
  }
  return { pkgOptionAvailableRooms, roomTypeAvailableRooms }
}
